import ProjectBox from './ProjectBox'
import { AiOutlineSchedule } from 'react-icons/ai'
import { BsRobot, BsCalculator } from 'react-icons/bs'
import { CgWebsite } from 'react-icons/cg'
import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

const Project = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })

  const variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 }
  }

  const projects = [
    {
      name: "Carleton Course Planner",
      content: "A schedule planner that helps Carleton students plan their courses for Fall 2023 and Winter 2024. The front-end is devleoped using ReactJs and Tailwind CSS, while the back-end is developed using NodeJS and MongoDB.",
      link: "https://github.com/Ianniu123/planner-backend",
      start: false,
      icon: <AiOutlineSchedule />,
    },
    {
      name: "Tic-tac-toe V.S. A.I.",
      content: "This is a tic-tac-toe game where the opponent is implemented using the mini-max algorithm. The GUI of the application is developed using the PyGame Library.",
      link: "https://github.com/Ianniu123/tictactoe-ai",
      start: true,
      icon: <BsRobot />,
    },
    {
      name: "Personal Website",
      content: "This project is the website that you are looking at right now! The front-end of this website is developed using a combination of ReactJs, Tailwind CSS, and Animate.css. The responsive design of this website is developed using Tailwind CSS.",
      link: "https://github.com/Ianniu123/Personal-Website",
      start: false,
      icon: <CgWebsite />,
    },
    {
      name: "GPA Calculator",
      content: "This program helps students calculate their GPAs' on a 4-point scale and a 12-point scale. The application is developed in Java and the GUI is implemented using the Swing Library.",
      link: "https://github.com/Ianniu123/GPA-Calculator",
      start: true,
      icon: <BsCalculator />,
    }
  ]

  return (
		<section ref={ref}>
			<div className="">
				<h1 className="flex items-center justify-center text-4xl mb-2 lg:mb-8">My Projects</h1>
        <div className="flex-col md:grid md:grid-cols-2 md:grid-rows-2">
            {projects.map((project, index) => {
              return ( 
                <motion.li
                  key={index} 
                  variants={variants} 
                  initial='initial' 
                  animate={isInView ? 'animate' : 'initial'}
                  transition={{ duration: 8, delay: index * 1 }}
                >
                  <ProjectBox 
                    project={project} 
                  />
                </motion.li>
              )
            })}
        </div>
      </div>
		</section>
  )
}

export default Project